module.exports = __webpack_public_path__ + "img/chickpea-hero-mobile.20401f0e.png";